export const VIEW_MODE = {
  SITE: 'SITE',
  EDIT: 'EDIT',
  PREVIEW: 'PREVIEW',
  SEO: 'SEO',
};
